import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

export interface DonutSlice {
  label: string;
  value: number;
  color: string;
}

/**
 * Simple ring/donut chart with custom center content overlay — matches the
 * "Customer Base" and "Total Subscriptions" widget styles used across the
 * dashboard (big number in the middle, thin label underneath).
 */
export default function DonutChart({
  data,
  size = 168,
  thickness = 20,
  centerValue,
  centerLabel,
}: {
  data: DonutSlice[];
  size?: number;
  thickness?: number;
  centerValue: React.ReactNode;
  centerLabel?: string;
}) {
  const outerRadius = size / 2;
  const innerRadius = outerRadius - thickness;

  return (
    <div style={{ position: 'relative', width: size, height: size, flexShrink: 0 }}>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="label"
            cx="50%"
            cy="50%"
            innerRadius={innerRadius}
            outerRadius={outerRadius}
            startAngle={90}
            endAngle={-270}
            stroke="none"
            cornerRadius={data.length > 1 ? 3 : 0}
            paddingAngle={data.length > 1 ? 2 : 0}
          >
            {data.map((slice, i) => (
              <Cell key={i} fill={slice.color} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
      <div
        style={{
          position: 'absolute', inset: 0,
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          pointerEvents: 'none',
        }}
      >
        <span style={{ fontSize: size * 0.155, fontWeight: 900, color: '#111827', letterSpacing: '-0.02em', lineHeight: 1 }}>
          {centerValue}
        </span>
        {centerLabel && (
          <span style={{ fontSize: 10, fontWeight: 800, color: '#9ca3af', letterSpacing: '0.06em', marginTop: 4 }}>
            {centerLabel}
          </span>
        )}
      </div>
    </div>
  );
}
